export default angular.module('mdIcons', [])
    .config(['$mdIconProvider', '$sceDelegateProvider', function ($mdIconProvider, $sceDelegateProvider) {
        $sceDelegateProvider.resourceUrlWhitelist([
            'self',
            //_put_whitelist_url_here_for_angular_app
            // do not remove above comment, it's been use to put the whitelist url on the go
        ]);
        $mdIconProvider.defaultIconSet(require('./mdi.csvg'));
    }]);